import { createAction } from 'Helpers';
import createActionWithAppend from 'Helpers/createActionWithAppend';
import couponTypes from './types';

const couponActions = {
	getCouponsRequest: createActionWithAppend(couponTypes.GET_COUPON.REUQEST),
	getCouponsSuccess: createActionWithAppend(couponTypes.GET_COUPON.SUCCESS),
	getCouponsFailure: createAction(couponTypes.GET_COUPON.FAILURE),
	clearCouponsFailure: createAction(couponTypes.GET_COUPON.CLEAR),

	getCouponsMobileRequest: createAction(couponTypes.GET_COUPON_MOBILE.REUQEST),
	getCouponsMobileSuccess: createAction(couponTypes.GET_COUPON_MOBILE.SUCCESS),
	getCouponsMobileFailure: createAction(couponTypes.GET_COUPON_MOBILE.FAILURE),

	invalidateCouponsRequest: createAction(couponTypes.INVALIDATE_COUPON.REUQEST),
	invalidateCouponsSuccess: createAction(couponTypes.INVALIDATE_COUPON.SUCCESS),
	invalidateCouponsFailure: createAction(couponTypes.INVALIDATE_COUPON.FAILURE),
	getCouponsOrderRequest: createAction(couponTypes.GET_COUPON_ORDER.REUQEST),
	getCouponsOrderSuccess: createAction(couponTypes.GET_COUPON_ORDER.SUCCESS),
	getCouponsOrderFailure: createAction(couponTypes.GET_COUPON_ORDER.FAILURE),

	getCouponsInvalidationSearchRequest: createActionWithAppend(
		couponTypes.GET_COUPON_INVALIDATION_SEARCH.REUQEST
	),
	getCouponsInvalidationSearchSuccess: createAction(
		couponTypes.GET_COUPON_INVALIDATION_SEARCH.SUCCESS
	),
	getCouponsInvalidationSearchFailure: createAction(
		couponTypes.GET_COUPON_INVALIDATION_SEARCH.FAILURE
	),
};

export default couponActions;
